module.exports = __webpack_public_path__ + "static/media/checkbox_icon.3a4a6ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkbox_icon.svg
// module id = 148
// module chunks = 0